import './styles.scss';

import React, {CSSProperties, PropsWithChildren} from 'react';

interface AppMessageErrorProps extends PropsWithChildren {
    style?: CSSProperties;
}

export const AppMessageError = ({children, style}: AppMessageErrorProps) => {
    return (
        <div className='app-message-error' style={style} dangerouslySetInnerHTML={{__html: children + ''}} />
    );
};
